export default __webpack_public_path__ + "static/2-23c3bb0c028893db5f74910cc453435d.jpeg";